import { render, staticRenderFns } from "./UpdateShipmentButton.vue?vue&type=template&id=3ff51046&scoped=true&"
import script from "./UpdateShipmentButton.vue?vue&type=script&lang=js&"
export * from "./UpdateShipmentButton.vue?vue&type=script&lang=js&"
import style0 from "./UpdateShipmentButton.vue?vue&type=style&index=0&id=3ff51046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff51046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff51046')) {
      api.createRecord('3ff51046', component.options)
    } else {
      api.reload('3ff51046', component.options)
    }
    module.hot.accept("./UpdateShipmentButton.vue?vue&type=template&id=3ff51046&scoped=true&", function () {
      api.rerender('3ff51046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/buttons/UpdateShipmentButton.vue"
export default component.exports